/**
 * Phase 1 default skills, typed as `Skill[]` against `@sill/types`. The
 * authoritative copy of the seven defaults (CLAUDE.md §6) — promoted
 * from `apps/dashboard/src/views/onboarding/default-skills.ts` per ADR-0010
 * implementer's-call item 3 so the dashboard, the origin `POST /v1/sites`
 * handler, and the edge bundled-skills fallback all source the same list.
 *
 * Mirrors `Foyer_Dashboard_CURRENT.jsx` line 1287; `auth_required = true`
 * ONLY on `place_order` and `request_refund` per
 * `vault/projects/sill/wiki/discovery-mode.md`. Order is load-bearing for
 * the agent-card canonical-form stability — see
 * `apps/edge/src/card/default-skills.ts`.
 *
 * `site_id` is the placeholder `__default__`; consumers replace it with
 * the active site's id before saving. `created_at` is a placeholder
 * timestamp; consumers overwrite with `now()` at insert time.
 */
const PLACEHOLDER_SITE_ID = '__default__';
const PLACEHOLDER_CREATED_AT = '2026-05-27T00:00:00Z';
const sid = (s) => s;
export const DEFAULT_SKILLS = [
    {
        skill_id: sid('browse_catalog'),
        site_id: PLACEHOLDER_SITE_ID,
        name: 'Browse catalog',
        description: 'Search and browse the product catalog',
        request_schema: {},
        auth_required: false,
        enabled: true,
        created_at: PLACEHOLDER_CREATED_AT,
    },
    {
        skill_id: sid('check_availability'),
        site_id: PLACEHOLDER_SITE_ID,
        name: 'Check availability',
        description: 'Check real-time stock and availability',
        request_schema: {},
        auth_required: false,
        enabled: true,
        created_at: PLACEHOLDER_CREATED_AT,
    },
    {
        skill_id: sid('place_order'),
        site_id: PLACEHOLDER_SITE_ID,
        name: 'Place order',
        description: 'Place an order with a signed payment authorization',
        request_schema: {},
        auth_required: true,
        enabled: true,
        created_at: PLACEHOLDER_CREATED_AT,
    },
    {
        skill_id: sid('order_status'),
        site_id: PLACEHOLDER_SITE_ID,
        name: 'Order status',
        description: 'Look up the status of an order',
        request_schema: {},
        auth_required: false,
        enabled: true,
        created_at: PLACEHOLDER_CREATED_AT,
    },
    {
        skill_id: sid('track_shipment'),
        site_id: PLACEHOLDER_SITE_ID,
        name: 'Track shipment',
        description: 'Track the shipment for an order',
        request_schema: {},
        auth_required: false,
        enabled: true,
        created_at: PLACEHOLDER_CREATED_AT,
    },
    {
        skill_id: sid('request_refund'),
        site_id: PLACEHOLDER_SITE_ID,
        name: 'Request refund',
        description: 'Request a refund or return',
        request_schema: {},
        auth_required: true,
        enabled: true,
        created_at: PLACEHOLDER_CREATED_AT,
    },
    {
        skill_id: sid('recommend'),
        site_id: PLACEHOLDER_SITE_ID,
        name: 'Recommend',
        description: 'Get product recommendations',
        request_schema: {},
        auth_required: false,
        enabled: true,
        created_at: PLACEHOLDER_CREATED_AT,
    },
];
//# sourceMappingURL=default-skills.js.map